import axios from "axios";
// const xWWWFormURLEncoder = require("./formUrlEncoder");
import xWWWFormURLEncoder from "./urlEncoder";

export default class BaseServices {
  static get(props) {
    const { query, url, ...other } = props;

    return BaseServices.request({
      method: "get",
      url: url,
      params: query,
      ...other,
    });
  }

  static post({ query, url }) {
    const queryURLEncode = xWWWFormURLEncoder.write(query);
    return BaseServices.request({
      method: "post",
      url: url,
      data: queryURLEncode,
    });
  }

  static request(options = {}) {
    const axiosOption = { ...options, withCredentials: true };
    axios.defaults.withCredentials = true;

    return axios
      .request(axiosOption)
      .then((res) => Promise.resolve(res))
      .catch((error) => {
        if (error.response) {
          return Promise.reject(error.response);
        }
        return Promise.reject(error);
      });
  }

  static PostRequest({ headers, data, url }) {
    const queryURLEncode = xWWWFormURLEncoder.write(data);
    axios.defaults.withCredentials = true;
    return (
      axios
        .post(url, queryURLEncode, { headers, withCredentials: true })
        .then((res) => Promise.resolve(res))
        .catch((error) => {
          if (error.response) {
            return Promise.reject(error.response);
          }
          return Promise.reject(error);
        })
    );
  }
}
